import eventBus from './helpers/event_bus';
export const __vueEvent = eventBus;
export const __oneMinute = 60000;
export const __onTransitionEnd = "animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd";
export const _convId = 'conv_id';
export const __maintainState = "maintain_state";
export const __maintainStateTime = "maintain_state_time";
export let WebChatConnectionRetryWarningCount = '';
export let WebChatConnectionRetryInterval = '';
export const __hideInputContainerAlways = "hide_input_container_always";
export const __locationCheckTimeout = 10000;
export const __locationCheckInterval = 100;
export const __messageTimestamp = "swc_msg_ts_"; // SD-5918: Message timestamp storage key
export const CAROUSEL_RADIUS = "12px";

/**
 * JIRA: SD-13645
 * Default carousel card surface.
 *
 * Falls back to --cardBgColor, the token every theme already defines for card surfaces, before
 * the documented #FFF literal. Measured on the Giants themes: the light ones set it to #ffffff
 * (identical to the old hardcoded default, so nothing changes), while the dark one sets
 * #1B141C - which is what stops the card body rendering as a white slab on a dark panel.
 * --carouselItemBgColor stays available for a carousel-specific override.
 */
export const CAROUSEL_ITEM_BG = "var(--carouselItemBgColor, var(--cardBgColor, #FFF))";

/**
 * JIRA: SD-13645
 * How close to the bottom the chat must be for a late-loading carousel image to re-anchor it.
 * Generous enough to cover a few pixels of rounding, small enough that a reader who has
 * deliberately scrolled up is never pulled back down.
 */
export const IMAGE_LOAD_SCROLL_THRESHOLD = 120;
